import { Component, Input, OnInit } from '@angular/core'
import { NaturalStoneCartLine } from '../../../interfaces/natural-stone/natural-stone-cart'
import { DomSanitizer, SafeUrl } from '@angular/platform-browser'
import { NumberStepperComponent } from '@components/number-stepper/number-stepper.component'
import { NaturalStoneService } from '../../../services/natural-stone.service'
import { NaturalStoneColorService } from '../../../services/natural-stone-color.service'
import { TranslateModule } from '@ngx-translate/core'
import { DecimalPipe, NgIf, } from '@angular/common'

@Component({
  selector: 'app-natural-stone-cart-line',
  standalone: true,
    imports: [
        NumberStepperComponent,
        TranslateModule,
        DecimalPipe,
        NgIf,
    ],
  templateUrl: './natural-stone-cart-line.component.html',
  styleUrl: './natural-stone-cart-line.component.scss'
})
export class NaturalStoneCartLineComponent implements OnInit {
    @Input() line!: NaturalStoneCartLine
    @Input() minicart: boolean = false

    imageSrc: SafeUrl
    finishLabel: string;
    id?: string;
    surfaceArea: number;

    constructor(
        private sanitizer: DomSanitizer,
        private colorService: NaturalStoneColorService,
        private naturalStoneService: NaturalStoneService,
    ) {
    }

    ngOnInit() {
        if(this.line.color.imageUrl && this.line.color.imageUrl.startsWith('https')){
            this.imageSrc = this.sanitizer.bypassSecurityTrustUrl(this.line.color.imageUrl + "?width=300") //NOSONAR
        } else {
            this.imageSrc = "assets/images/processing-image.png"
        }

        this.id = this.line.lot.bundleId ? this.line.lot.bundleId : this.line.lot.lotId
        this.surfaceArea = this.colorService.getSurfaceArea(this.line.lot) || 0;
        this.getFinish()
    }

    updateQuantity(newQty: number) {
        this.line.qty = newQty
    }

    getColorText(){
        return this.colorService.getColorText(this.line.color)
    }

    getBrandText(){
        return this.colorService.getBrandText(this.line.color)
    }

    getThickness() {
        return this.colorService.getThickness(this.line.color.thickness!)
    }

    getFinish() {
        this.colorService.getFinish(this.line.color.finish!).then(finishLabel => {
            this.finishLabel = finishLabel
        })
    }

    getWidth(){
        return this.colorService.getWidth(this.line.lot)
    }

    getHeight(){
        return this.colorService.getHeight(this.line.lot)
    }

    getMeasureUnit(){
        return this.colorService.getMeasureUnit()
    }

    getSurfaceAreaMeasure(){
        return this.colorService.getSurfaceAreaMeasure()
    }

    removeFromCart(line: NaturalStoneCartLine) {
        this.naturalStoneService.removeLotFromCart(line.lot)
    }
}
